module.exports = __webpack_public_path__ + "static/media/bilten1.d4202d91.png";